<template>
  <ul>
    <li v-for="(vaccination) in vaccinations"
        :key="vaccination.id"
        class="text-capitalize list__item">

      <ul>
        <li v-for="(ccd, index) in vaccination.codes" :key="index">
          <span v-if="vaccination.lo">{{ vaccination.lo }} -</span>
          <text-highlight :queries="keywords">
            {{ getCcdDescriptionById(ccd) }}
          </text-highlight>
        </li>
      </ul>

    </li>
  </ul>
</template>

<script>
  import { getDescByCcd } from '@/data/getters.js';
  import { mapGetters } from 'vuex';

  export default {
    name: "VaccinationDetail",
    props: {
      vaccinations: Array,
      keywords: Array,
    },
    computed: {
      ...mapGetters('login', {
        allData: 'getAllData',
      })
    },
    methods: {
      getCcdDescriptionById(id) {
        return getDescByCcd(id, this.allData);
      }
    }
  }
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
    padding: 0;
  }
  .list__item {
    padding: 0.75em 1.25em;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    margin-bottom: 0.75em;
  }
</style>
